import * as React from 'react';

import { UitkLinkProps } from 'uitk-react-link';
import { UitkBanner } from 'uitk-react-banner';
import { classNames, Level, liveAnnounce } from 'uitk-react-utils';

import { FlightsIconPlacard } from 'types/shared';
import { analyticsConfigMapper } from 'utility';
import { useStores } from 'utility/hooks';

interface BannersProps {
  classes?: string;
}

export const Banners = ({ classes }: BannersProps) => {
  const { analytics, bannersStore } = useStores();
  const { banners } = bannersStore;
  const bannerClass = classNames({ [classes]: classes });

  if (!banners || banners.length === 0) {
    return null;
  }

  return (
    <div className={bannerClass} data-test-id="banners-container">
      {banners.map((banner: FlightsIconPlacard, index: number) => {
        const { icon, heading, message, actions } = banner;
        const primaryAction = actions && actions[0];
        const secondaryAction = actions && actions[1];
        const analyticsPrimary: UitkLinkProps = {
          analytics:
            primaryAction && primaryAction.analytics && analyticsConfigMapper(primaryAction.analytics, analytics)
        };
        const analyticsSecondary: UitkLinkProps = {
          analytics:
            secondaryAction && secondaryAction.analytics && analyticsConfigMapper(secondaryAction.analytics, analytics)
        };
        setTimeout(() => liveAnnounce(message, Level.POLITE), 500);

        return (
          <div
            className={classNames({
              'all-b-margin-six s-b-margin-three m-b-margin-three': index + 1 !== banners.length
            })}
            key={`banner-${index}`}
          >
            <UitkBanner
              icon={icon && icon.id}
              message={message}
              heading={heading}
              linkOneHref={primaryAction && primaryAction.relativeURI && primaryAction.relativeURI.relativePath}
              linkOneText={primaryAction && primaryAction.displayAction}
              linkOneAttributes={analyticsPrimary}
              linkTwoHref={secondaryAction && secondaryAction.relativeURI && secondaryAction.relativeURI.relativePath}
              linkTwoText={secondaryAction && secondaryAction.displayAction}
              linkTwoAttributes={analyticsSecondary}
            />
          </div>
        );
      })}
    </div>
  );
};
